// ANCHOR React
import { memo } from 'react';

// ANCHOR Base
import {
  ModalBody, ModalHeader, SIZE, ROLE,
} from 'baseui/modal';
import { LabelLarge } from 'baseui/typography';

// ANCHOR Models
import { CreateFormQuestionForm } from '@lyon/scoped-models/form/create/CreateFormQuestionForm';
import { useCreateFormQuestionModalVisibilityStateAndHide } from '@lyon/scoped-models/form/create/CreateFormQuestionModalVisibility';

// ANCHOR Components
import { Divider } from '@lyon/components/utils/Divider';
import { CloseModal } from '@lyon/components/utils/CloseModal';
import { LyonCreateFormQuestionName } from './LyonCreateFormQuestionName';
import { LyonCreateFormQuestionType } from './LyonCreateFormQuestionType';
import { LyonCreateFormQuestionSubmit } from './LyonCreateFormQuestionSubmit';

// ANCHOR Styles
import { MODAL } from './styles';
import { LyonCreateFormQuestionNotification } from './LyonCreateFormQuestionNotification';

interface IProps {
  formId: string;
  length: number;
}

export const LyonCreateFormQuestion = memo(({ formId, length }: IProps) => {
  const [isOpen, onClose] = useCreateFormQuestionModalVisibilityStateAndHide();

  return (
    <CloseModal
      isOpen={isOpen}
      onClose={onClose}
      size={SIZE.default}
      role={ROLE.dialog}
      overrides={MODAL}
      animate
      autoFocus
      closeable
    >
      <ModalHeader>
        <LabelLarge>
          Create a Question
        </LabelLarge>
        <Divider />
      </ModalHeader>
      <ModalBody>
        <CreateFormQuestionForm.Provider formId={formId} length={length}>
          <LyonCreateFormQuestionNotification />
          <LyonCreateFormQuestionName />
          <LyonCreateFormQuestionType />
          <LyonCreateFormQuestionSubmit />
        </CreateFormQuestionForm.Provider>
      </ModalBody>
    </CloseModal>
  );
});
